async function convertToJpegBase64(file, quality = 0.95) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0); // draw directly, no background

        const jpegBase64 = canvas.toDataURL("image/jpeg", quality);
        resolve(jpegBase64);
      };
      img.onerror = reject;
      img.src = reader.result;
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export { convertToJpegBase64 };
